import styled from 'styled-components/macro'

import PopupItem from './PopupItem'
import { MEDIA_WIDTHS } from '../../Themes'
import { AutoColumn } from '../../catalog/layout/AutoColumn'
import { useContext } from 'react'
import { Web3Context } from '../../../hooks/web3'
import { useTransactions } from '../../transactions/TransactionContext'
import { Transaction } from '../../../logic/transactions/transactions'
import { isViewTrade } from '../../header/HeaderTabs'

export type PopupContent = {
  transaction: Transaction
}

export interface Popup {
  show: boolean
  key: string
  content: PopupContent
  removeAfterMs: number | null
}

const MobilePopupWrapper = styled.div<{ height: string | number }>`
  font-size: 1.6rem;
  position: relative;
  max-width: 100%;
  height: ${({ height }) => height};
  margin: ${({ height }) => (height ? '0 auto;' : 0)};
  margin-bottom: ${({ height }) => (height ? '20px' : 0)};

  display: none;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: block;
  `};
`

const MobilePopupInner = styled.div`
  font-size: 1.4rem;
  height: 99%;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: row;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
  }
`

const StopOverflowQuery = `@media screen and (min-width: ${
  MEDIA_WIDTHS.upToMedium + 1
}px) and (max-width: ${MEDIA_WIDTHS.upToMedium + 500}px)`

const FixedPopupColumn = styled(AutoColumn)<{
  extraPadding: boolean
  xlPadding: boolean
}>`
  position: fixed;
  top: 80px;
  right: 1rem;
  max-width: 280px !important;
  width: 100%;
  z-index: 3;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};

  ${StopOverflowQuery} {
    top: 80px;
  }
`

export default function Popups() {
  // get all popups
  const { transactions } = useTransactions()

  const activePopups: Popup[] = transactions.pops.map(tx => ({
    content: { transaction: tx },
    key: tx.submitted.hash,
    show: tx.type === 'swap' ? !tx.uiRef!.current : true,
    removeAfterMs: 10_000,
  }))

  // (maybe) case with banner not implemented yet
  const showSurveyPopup = false

  return (
    <>
      <FixedPopupColumn gap="10px" extraPadding={false} xlPadding={false}>
        {/* not implemented <ClaimPopup />*/}
        {/* not implemented <SurveyPopup />*/}
        {activePopups
          .filter(item => item.show)
          .map(item => (
            <div style={{ fontSize: '1.6rem' }} key={item.key}>
              <PopupItem
                content={item.content}
                popKey={item.key}
                removeAfterMs={item.removeAfterMs}
              />
            </div>
          ))}
      </FixedPopupColumn>
      <MobilePopupWrapper
        height={activePopups?.length > 0 || showSurveyPopup ? 'fit-content' : 0}
      >
        <MobilePopupInner>
          {/* not implemented < SurveyPopup />*/}
          {activePopups // reverse so new items up front
            .slice(0)
            .reverse()
            .map(item => (
              <PopupItem
                key={item.key}
                content={item.content}
                popKey={item.key}
                removeAfterMs={item.removeAfterMs}
              />
            ))}
        </MobilePopupInner>
      </MobilePopupWrapper>
    </>
  )
}
